import AccordionSection from '@profile/pages/AccountPage/components/AccordionSection/AccordionSection';
import * as React from 'react';

import * as styles from './FaqSectionStyles.module.scss';

export const FaqSection = () => (
  <div className={styles.faqSection}>
    <h2>Frequently Asked Questions about Chapter 11 Claim Feature</h2>
    <div>
      <AccordionSection
        mobileWidth={5600}
        label="Will I be transferring my claim from Celsius to Bnk To The Future?"
      >
        <p>
          No, This feature is for informational purposes only. No legal transfer
          of claim is being performed when the data is imported.
        </p>
      </AccordionSection>

      <AccordionSection
        mobileWidth={5600}
        label="How much will I be able to use? Is there a haircut?"
      >
        <p>
          Once the import is accepted, you will be able to see your total claim
          as per the schedule of the asset. We then display 40% of the value of
          your BTC, ETH and USD stablecoins. Only that part will be made usable
          for any upcoming creditor opportunities.
        </p>
      </AccordionSection>

      <AccordionSection
        mobileWidth={5600}
        label="I have a loan and collateral but they are not showing?"
      >
        <p>
          We are only taking the funds under “earn” and “custody” for now for
          this feature.
        </p>
      </AccordionSection>

      <AccordionSection
        mobileWidth={5600}
        label="What will I be able to do on Bnk To The Future?"
      >
        <p>
          We are currently gauging the community interest and releasing new
          features on the Bnk To The Future platform as the Chapter 11 process
          progresses so that you can voluntarily invest or use your claim to
          express your interest in certain actions in the future.
        </p>
      </AccordionSection>

      <AccordionSection
        mobileWidth={5600}
        label="My claim data is not matching up what is displayed on the platform. There appears to be a mistake?

        "
      >
        <p>
          Please contact our Bnk to The Future support team at{' '}
          <a
            href="mailto:info@banktothefuture.com"
            title="info@banktothefuture.com"
          >
            info@banktothefuture.com
          </a>
          &nbsp; and we will be happy to review and adjust the information if any
          errors have been found.
        </p>
      </AccordionSection>

      <AccordionSection
        mobileWidth={5600}
        label="Can I connect my claim from another company that is under chapter 11 (Voyager, FTX…)?"
      >
        <p>
          At present, this feature only works for Celsius at the moment. We plan
          to expand the feature to all relevant future chapter 11 cases where we
          believe that Bnk To The Future can have the most impact on.
        </p>
      </AccordionSection>
    </div>
  </div>
);
